import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDifferenceIgnored: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDifferenceIgnored"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7.79297 14.793L9.20703 16.207L16.207 9.20703L14.793 7.79297L7.79297 14.793Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDifferenceIgnored;
